import normalizeProjectId from '@/lib/normalizeProjectId.js';
import getFirstValidThreadTimestamp from '@/lib/threads/getFirstValidThreadTimestamp.js';
import normalizeParentThreadId from '@/lib/threads/normalizeParentThreadId.js';

const normalizeThreadRecord = ({ value, existingThread = null, fallbackProjectId = null, fallbackCreatedAtCandidates = [], fallbackUpdatedAtCandidates = [], fallbackArchivedAtCandidates = [] } = {}) => {
  const thread = value?.thread || value;
  const threadId = thread?.id || thread?.threadId || null;
  const safeExistingThread = existingThread && typeof existingThread === 'object' ? existingThread : {};

  if (!thread || !threadId) {
    return null;
  }

  const createdAt = getFirstValidThreadTimestamp([thread?.createdAt, thread?.created_at, safeExistingThread?.createdAt, safeExistingThread?.created_at, thread?.updatedAt, thread?.updated_at, safeExistingThread?.updatedAt, safeExistingThread?.updated_at, ...(Array.isArray(fallbackCreatedAtCandidates) ? fallbackCreatedAtCandidates : [])]);
  const updatedAt = getFirstValidThreadTimestamp([thread?.updatedAt, thread?.updated_at, safeExistingThread?.updatedAt, safeExistingThread?.updated_at, thread?.createdAt, thread?.created_at, safeExistingThread?.createdAt, safeExistingThread?.created_at, ...(Array.isArray(fallbackUpdatedAtCandidates) ? fallbackUpdatedAtCandidates : []), createdAt]);
  const archivedAt = getFirstValidThreadTimestamp([thread?.archivedAt, thread?.archived_at, safeExistingThread?.archivedAt, safeExistingThread?.archived_at, ...(Array.isArray(fallbackArchivedAtCandidates) ? fallbackArchivedAtCandidates : [])]);
  const parentThreadId = normalizeParentThreadId(thread?.parentThreadId || thread?.parent_thread_id || thread?.parent?.threadId || thread?.parent?.id || safeExistingThread?.parentThreadId || safeExistingThread?.parent_thread_id);
  const projectId = normalizeProjectId(thread?.projectId || thread?.project?.id || thread?.project?.projectId || thread?.project_id || fallbackProjectId || safeExistingThread?.projectId || safeExistingThread?.project?.id || safeExistingThread?.project?.projectId || safeExistingThread?.project_id);

  return {
    ...thread,
    id: String(threadId),
    parentThreadId,
    ...(createdAt ? { createdAt } : {}),
    ...(updatedAt ? { updatedAt } : {}),
    ...(archivedAt ? { archivedAt } : {}),
    ...(projectId ? { projectId } : {})
  };
};

export default normalizeThreadRecord;
